  async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
  async function updateCartDrawer2() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_bar_wrapper").innerHTML;
  document.querySelector(".u_cart_bar_wrapper").innerHTML = newBox;
}
$(function(){
 console.log('currency',window.Shopify.currency.active);
   var currentCurrency = window.Shopify.currency.active;
  // ensure numeric value output (no quotes) and fallback to 0 if empty
  var c_thre = 150;

  // currency rate map (same as your Liquid case)
  var currencyRates = {
    "EUR": 1,
    "USD": 1.17,
    "GBP": 0.85,
    "JPY": 162,
    "AUD": 1.63,
    "CAD": 1.47,
    "CHF": 0.98,
    "CNY": 7.82,
    "HKD": 8.45,
    "NZD": 1.76,
    "SEK": 11.28,
    "SGD": 1.45,
    "NOK": 11.48,
    "MXN": 18.16,
    "INR": 89.87,
    "RUB": 100.15,
    "ZAR": 20.26,
    "TRY": 34.78,
    "BRL": 5.43,
    "KRW": 1472.69,
    "PLN": 4.26,
    "PHP": 61.12,
    "CZK": 24.71,
    "DKK": 7.46,
    "HUF": 383.37,
    "ILS": 4.00,
    "THB": 39.49,
    "CLP": 1007.36,
    "IDR": 17216.25,
    "MYR": 5.09
  };

  // pick rate, default to 1 if not listed
  var currencyRate = currencyRates[currentCurrency] !== undefined ? currencyRates[currentCurrency] : 1;
console.log('currency  rates',currencyRate)
  // compute shipping threshold in currency units and round (same as Liquid | round)
  var shippFlag = Math.round(c_thre * currencyRate);
console.log('currency  rates mult',shippFlag)
var symbol = $('body').attr('data-sym');
console.log(symbol);
$('.u_policy_shi_price').text(`${symbol}${shippFlag}`);
  function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);
      $('.cart-link__count').text(result);
      });
    }
  $(document).on('change','.u_upp_var_select',function(){
    let selected_val = $(this).find('option:selected').val().trim()
    console.log('selected value',selected_val)
    $(this).closest('.product-block').find('.u_upp_pro_atc').attr('var-id',selected_val)
  })
    $(document).on('click','.u_upp_pro_atc',function(){
     let variant_id = $(this).attr('var-id').trim()
    let ths = $(this);
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data : {
        "id": variant_id,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('add to cart');

      },
         beforeSend: function() {
       ths.closest('.product-block').find('.u_cart_btn_val').addClass('active');
ths.closest('.product-block').find('.u_loading_state').addClass('active');
         },
                    error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
           updateCartDrawer();
           setTimeout(function(){
             getCartCount();
                        $('.cart-link__icon').trigger('click')
           },1500)
                  ths.closest('.product-block').find('.u_cart_btn_val').removeClass('active');
ths.closest('.product-block').find('.u_loading_state').removeClass('active');

      }
    })
    })
  $(document).on('click','.js-close-drawer,.overlay',function(){
     $('.u_cart_drawer').removeAttr('open')
              $('.overlay').removeClass('is-visible')
  })
  $(document).on('click','.u_bundle_atc',function(e){
    e.preventDefault()
    console.log('rook')
     let ths = $(this);
    let bundle_data = $(this).closest('form').serialize();
    console.log('bundle_data',bundle_data)
        $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data :bundle_data,
 dataType: 'json',
        success: function(result){
        console.log('add to cart');

      },
         beforeSend: function() {
                  ths.closest('.u_bundle_atc').find('.u_cart_btn_val').addClass('active');
ths.closest('.u_bundle_atc').find('.u_loading_state').addClass('active');
         },
                    error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
           updateCartDrawer();
           setTimeout(function(){
             getCartCount();
                        $('.cart-link__icon').trigger('click')
             
           },1500)
                      ths.closest('.u_bundle_atc').find('.u_cart_btn_val').removeClass('active');
ths.closest('.u_bundle_atc').find('.u_loading_state').removeClass('active');

      }
    })
  })
  $(document).on('click','.quantity-up,.quantity-down,.add-to-cart,.u_bundle_atc',function(){
       
    console.log('clickk')
  setTimeout(function(){
                      updateCartDrawer2();
  },1500)
  })

})